import React from 'react';

const WhoisSection = ({ wan1Command, wan2Command, copyToClipboard }) => {
  return (
    <div className='flex flex-col p-6 bg-slate-100 rounded-2xl border-red-600 border-solid border-2'>
      <h1 className='font-bold text-3xl mb-4'>Linux command whois</h1>

      <div className='space-y-4 p-4 bg-white rounded-lg shadow'>
        <div>
          <h2 className='font-semibold text-lg mb-2'>Who is WAN1:</h2>
          <div className='p-3 bg-gray-100 rounded font-mono text-sm break-all'>
            {wan1Command}
          </div>
          <button
            onClick={() => copyToClipboard('whoisWan1', wan1Command)}
            className='mt-2 px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 flex items-center gap-2'
          >
            <svg
              xmlns='http://www.w3.org/2000/svg'
              fill='none'
              viewBox='0 0 24 24'
              strokeWidth={1.5}
              stroke='currentColor'
              className='w-5 h-5'
            >
              <path
                strokeLinecap='round'
                strokeLinejoin='round'
                d='M15.666 3.888A2.25 2.25 0 0 0 13.5 2.25h-3c-1.03 0-1.9.693-2.166 1.638m7.332 0c.055.194.084.4.084.612v0a.75.75 0 0 1-.75.75H9a.75.75 0 0 1-.75-.75v0c0-.212.03-.418.084-.612m7.332 0c.646.049 1.288.11 1.927.184 1.1.128 1.907 1.077 1.907 2.185V19.5a2.25 2.25 0 0 1-2.25 2.25H6.75A2.25 2.25 0 0 1 4.5 19.5V6.257c0-1.108.806-2.057 1.907-2.185a48.208 48.208 0 0 1 1.927-.184'
              />
            </svg>
            Copy to Clipboard
          </button>
          <p
            id='whoisWan1-message'
            className='hidden text-green-600 mt-1 text-sm'
          ></p>
        </div>

        <div>
          <h2 className='font-semibold text-lg mb-2'>Who is WAN2:</h2>
          <div className='p-3 bg-gray-100 rounded font-mono text-sm break-all'>
            {wan2Command}
          </div>
          <button
            onClick={() => copyToClipboard('whoisWan2', wan2Command)}
            className='mt-2 px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 flex items-center gap-2'
          >
            <svg
              xmlns='http://www.w3.org/2000/svg'
              fill='none'
              viewBox='0 0 24 24'
              strokeWidth={1.5}
              stroke='currentColor'
              className='w-5 h-5'
            >
              <path
                strokeLinecap='round'
                strokeLinejoin='round'
                d='M15.666 3.888A2.25 2.25 0 0 0 13.5 2.25h-3c-1.03 0-1.9.693-2.166 1.638m7.332 0c.055.194.084.4.084.612v0a.75.75 0 0 1-.75.75H9a.75.75 0 0 1-.75-.75v0c0-.212.03-.418.084-.612m7.332 0c.646.049 1.288.11 1.927.184 1.1.128 1.907 1.077 1.907 2.185V19.5a2.25 2.25 0 0 1-2.25 2.25H6.75A2.25 2.25 0 0 1 4.5 19.5V6.257c0-1.108.806-2.057 1.907-2.185a48.208 48.208 0 0 1 1.927-.184'
              />
            </svg>
            Copy to Clipboard
          </button>
          <p
            id='whoisWan2-message'
            className='hidden text-green-600 mt-1 text-sm'
          ></p>
        </div>
      </div>
    </div>
  );
};

export default WhoisSection;